module.exports = __webpack_public_path__ + "img/cases-brand-hpnk-lazyload-01.0ccb51a6.jpg";